<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/prime/times";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.InputIcon v-tooltip.left="'Reset'" class="-mt-2.5!">
        <Icon class="text-gray-400 hover:text-gray-700 hover:cursor-pointer" @click="$emit('click')" />
    </PV.InputIcon>
</template>
